import type { Theme } from "@material-ui/core";
import { CardColors } from "./types";

export const getCardColor = (theme: Theme, color: CardColors) => {
  switch (color) {
    case CardColors.TRANSPARENT:
      return "transparent";
    default:
      return theme.palette[color].main;
  }
};
